import { render, staticRenderFns } from "./TipoTributacao.vue?vue&type=template&id=0fa5680b&"
import script from "./TipoTributacao.vue?vue&type=script&lang=js&"
export * from "./TipoTributacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports